export const SHELL = {
  root: "app-shell",
  topBar: "top-bar",
  brandMark: "brand-mark",
  back: "top-bar-back",
  title: "top-bar-title",
  bottomNav: "bottom-nav",
  navToday: "nav-today",
  navProgram: "nav-program",
  navDays: "nav-days",
  navLibrary: "nav-library",
  navProfile: "nav-profile",
};

export const KIT = {
  button: (name) => `btn-${name}`,
  programCard: (slug) => `program-card-${slug}`,
  programCardCta: (slug) => `program-card-cta-${slug}`,
  mealTile: (slot) => `meal-tile-${slot}`,
  mealTileToggle: (slot) => `meal-tile-eaten-${slot}`,
  mealTileRecipe: (slot) => `meal-tile-recipe-${slot}`,
  mealChoice: (slot) => `meal-choice-${slot}`,
  mealChoiceCount: (slot) => `meal-choice-count-${slot}`,
  mealOption: (slot, title) =>
    `meal-option-${slot}-${String(title).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`,
  mealTileImage: (slot) => `meal-tile-image-${slot}`,
  mealTileTitle: (slot) => `meal-tile-title-${slot}`,
  recipeModal: "recipe-modal",
  recipeModalClose: "recipe-modal-close",
  progressRing: "progress-ring",
  dayHero: "day-hero",
  dayHeroRing: "day-hero-ring",
  dayHeroMeals: "day-hero-meals",
  nutritionRow: (key) => `nutrition-${key}`,
  mealProgress: "meal-progress",
  weekIndex: "week-index",
  weekGroup: (w) => `week-group-${w}`,
  weekDay: (n) => `week-day-${n}`,
  guideSheet: "guide-sheet",
  lockedFeature: (key) => `locked-feature-${key}`,
  bundleNote: (kind) => `bundle-note-${kind}`,
  emptyState: "empty-state",
  sectionHeading: "section-heading",
  introLink: (slug) => `intro-link-${slug}`,
  guideLink: (key) => `guide-link-${key}`,
  guideSection: (key) => `guide-section-${key}`,
  guideWeekTab: (w) => `guide-week-tab-${w}`,
  shopItem: (id) => `shop-item-${id}`,
  shopProgress: (key) => `shop-progress-${key}`,
  recipePending: "recipe-pending",
  previewBanner: "preview-banner",
  previewTier: (t) => `preview-tier-${t}`,
  previewStatus: (slug) => `preview-status-${slug}`,
  introNav: (dir) => `intro-nav-${dir}`,
  resumeCta: "resume-cta",
  pageBand: "page-band",
  chapterDots: "chapter-dots",
  breadcrumbs: "breadcrumbs",
  breadcrumbLink: (i) => `breadcrumb-link-${i}`,
  stepNav: "step-nav",
  stepPrev: "step-prev",
  stepIndex: "step-index",
  stepSecondary: "step-secondary",
  stepNext: "step-next",
  dayIndexShortcut: "day-index-shortcut",
  backToProgram: "back-to-program",
  milestoneContinue: "milestone-continue",
  completionRestart: "completion-restart",
  completionLibrary: "completion-library",
  completionExplore: "completion-explore",
};

export const OPERATOR = {
  denied: "operator-denied",
  fullSync: "operator-full-sync",
  historyToggle: "operator-history-toggle",
  history: "operator-history",
  historyRow: (id) => `operator-history-row-${id}`,
  card: (slug) => `operator-card-${slug}`,
  syncNow: (slug) => `operator-sync-now-${slug}`,
  lastSync: (slug) => `operator-last-sync-${slug}`,
  updated: (slug) => `operator-updated-${slug}`,
  skipped: (slug) => `operator-skipped-${slug}`,
  failed: (slug) => `operator-failed-${slug}`,
  pending: (slug) => `operator-pending-${slug}`,
  validation: (slug) => `operator-validation-${slug}`,
  flags: (slug) => `operator-flags-${slug}`,
};

export const DOWNLOADS = {
  panel: "downloads-panel",
  item: (key) => `download-${key}`,
  locked: (key) => `download-locked-${key}`,
};

export const PAGES = {
  operator: "page-operator-console",
  openLink: "page-open-link",
  library: "page-library",
  programHome: "page-program-home",
  intro: "page-intro",
  days: "page-days",
  day: "page-day",
  guide: "page-guide",
  completion: "page-completion",
  weekMilestone: "page-week-milestone",
  profile: "page-profile",
  notFound: "page-not-found",
  kit: "page-kit-preview",
};
